import PropTypes from 'prop-types'
import { Box } from '@chakra-ui/react'
import { useLocation } from 'react-router-dom'
import { useAuthState } from '../../utils/login'
import React, { useEffect, useState } from 'react'
import { REPOSITORY } from '../../api/repository/Repository'
import LoadingView from '../../components/Loading/LoadingView'

export default function ProtectedRoute({ children, withoutPt, withoutPx }) {
  const [loading, setLoading] = useState(true)
  const location = useLocation()
  const state = useAuthState()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  useEffect(() => {
    setLoading(true)
    if (state.token) {
      REPOSITORY.wsEmpresa.password
        .verifyPasswordChange()
        .then((success) => {
          const resultPassword = success.data ? true : false

          if (
            !resultPassword &&
            /^\/password\/update/gm.test(location.pathname)
          ) {
            window.location.href = '/'
          } else if (
            resultPassword === true &&
            !/^\/password\/update/gm.test(location.pathname)
          ) {
            window.location.href = '/password/update'
          } else {
            setLoading(false)
          }
        })
        .catch(() => {
          setLoading(false)
        })
    } else {
      setLoading(false)
      window.location.href = '/login'
    }
  }, [])

  if (loading || !state.token) return <LoadingView open={true} />

  return (
    <Box
      pt={withoutPt ? '0px' : '120px'}
      px={withoutPx ? '0px' : '5%'}
      w="100%"
      h="100%"
      overflow={'auto'}
    >
      {children}
    </Box>
  )
}

ProtectedRoute.propTypes = {
  children: PropTypes.node,
  withoutPt: PropTypes.bool,
  withoutPx: PropTypes.bool,
}
